import React, { useState } from "react";
import PropTypes from "prop-types";
import MultiColumn from "../../sections/multi-column";
import PrimaryButton from "../../elements/primary-button";
import InputPhoneNumber from "../../elements/InputPhoneNumber";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import classNames from "classnames";
import "./style.scss";

const AppPushModule = ({ user, rendering, fields }) => {
  const {
    backgroundImage,
    alignment,
    headingType,
    headingBody,
    body,
    phoneAreaLabel,
    phoneLabel,
    phoneMissingMessage,
    phoneWarningMessage,
    submitSms,
    // smsSendFailed,
    // smsSendSuccess,
    showSmsSection,
    smsTextMessage,
    appStoreImage,
    appStoreUrl,
    googlePlayImage,
    googlePlayUrl,
    qrCodeImage,
    redirectPage
  } = fields;
  const badges = {
    playStore: {
      url: googlePlayUrl.value.href,
      image: googlePlayImage.value
    },
    appStore: {
      url: appStoreUrl.value.href,
      image: appStoreImage.value
    }
  };

  const Content = ({ type }) => {
    const [phoneNumber, setPhoneNumber] = useState(user?.mobileNo);
    const [phoneArea, setPhoneArea] = useState(user?.mobileNoCountryCode);
    const [phoneIsValid, setPhoneIsValid] = useState(false);
    const [submitTimestamp, setSubmitTimestamp] = useState();
    const onSubmit = () => {
      setSubmitTimestamp(new Date());
      console.log("send text to", phoneArea, phoneNumber, "mesage:", smsTextMessage.value, window, window.location + redirectPage.value.href);
    };
    const onPhoneChange = (area, number, isValid) => {
      setPhoneArea(area);
      setPhoneNumber(number);
      setPhoneIsValid(isValid);
    };

    return (
      <>
        <div className={classNames(type, alignment.value)}>
          <Heading html={headingBody} type={headingType} className="heading" />
          {body && <BodyText html={body.value} className="body" />}
          {showSmsSection.value && (
            <>
              <div className="phone-input">
                <InputPhoneNumber
                  phoneArea={{
                    className: "country-code",
                    label: phoneAreaLabel.value,
                    value: user?.mobileNoCountryCode
                  }}
                  phoneNumber={{
                    className: "phone-number",
                    label: phoneLabel.value,
                    value: user?.mobileNo
                  }}
                  warningMessage={phoneWarningMessage.value}
                  missingMessage={phoneMissingMessage.value}
                  onChange={(area, number, isValid) => {
                    onPhoneChange(area, number, isValid);
                  }}
                  onInit={(area, number, isValid) => {
                    onPhoneChange(area, number, isValid);
                  }}
                  submitTimestamp={submitTimestamp}
                />
              </div>
              <PrimaryButton {...{ ...submitSms.fields, buttonText: submitSms.fields.buttonText.value }} isDisabled={!phoneIsValid} callback={() => onSubmit()} />
            </>
          )}
        </div>

        <div
          className={classNames(
            "badges",
            type,
            {
              [`badges-row ${alignment.value}`]: !showSmsSection.value
            },
            {
              opposite: showSmsSection.value
            }
          )}
        >
          <a href={badges.appStore.url}>
            <img {...badges.appStore.image} />
          </a>
          <a href={badges.playStore.url}>
            <img {...badges.playStore.image} />
          </a>
        </div>
      </>
    );
  };

  return (
    <div className="app-push-module" datasourceid={rendering.dataSource}>
      <MultiColumn className="background" type="grid" backgroundImage={backgroundImage.value.src}>
        <Content type="content-tablet" />
        {qrCodeImage?.value?.src && (
          <div className="qr-code opposite">
            <img {...qrCodeImage.value} />
          </div>
        )}
      </MultiColumn>
      <div className="caption grid">{<Content type="content-mobile" />}</div>
    </div>
  );
};

const BadgeProp = PropTypes.shape({
  src: PropTypes.string,
  alt: PropTypes.string,
  url: PropTypes.string
});

AppPushModule.propTypes = {
  heading: PropTypes.object,
  body: PropTypes.object,
  phoneInput: PropTypes.shape({
    phoneArea: PropTypes.object,
    phoneNumber: PropTypes.object
  }),
  badges: PropTypes.shape({
    playStore: BadgeProp,
    appStore: BadgeProp
  }),
  button: PropTypes.object,
  onSubmit: PropTypes.func
};

export default AppPushModule;
